// extracted by mini-css-extract-plugin
module.exports = {"container":"UserDropdownMenu_container__DewFA","label":"UserDropdownMenu_label__16JFL"};